module.exports = __webpack_public_path__ + "img/Norway.d2715274.png";